import styled from '@emotion/styled';
import React from 'react';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';
import { LegacyVideoPlayer } from 'src/modules/programs/components/LegacyVideoPlayer';
import * as S from 'src/modules/programs/stepComponents/styles';
import { getVideoUrlById } from 'src/modules/videos/selectors/videosSelectors';

import { withTranslation, WithTranslation } from 'react-i18next';

const VideoWrapper = styled('div')({
    marginTop: '1.5rem',
});

interface Props extends WithTranslation {
    videoUrl: string;
}

const WhatIsMindfulnessStepContainer: React.SFC<Props> = ({ videoUrl, t }) => (
    <S.ContentRow>
        <S.ContentColumn>
            <S.StepHeading>{t('week-1.what-is-mindfulness.heading')}</S.StepHeading>
            <S.StepDescription>{t('week-1.what-is-mindfulness.description')}</S.StepDescription>
            <VideoWrapper>
                <LegacyVideoPlayer title={t('week-1.what-is-mindfulness.heading')} src={videoUrl} />
            </VideoWrapper>
        </S.ContentColumn>
    </S.ContentRow>
);

const mapStateToProps = (state: AppState) => ({
    videoUrl: getVideoUrlById(state, 'what-is-mindfulness-week-1'),
});

export const WhatIsMindfulnessStep = withTranslation('cp')(
    connect(mapStateToProps)(WhatIsMindfulnessStepContainer),
);
